// Copyright (c) 2016 Deere & Company

import Home from '../home-page/state-connector';

export default {
    component: Home,
    name: 'HOME'
};



// WEBPACK FOOTER //
// ./src/routes/home.js